module.exports = __webpack_public_path__ + "static/media/articleEnd.a224ed13.svg";